import Component from '../classes/Component';
import {$events} from '../helpers/events';
import {$dom} from '../helpers/dom';
import {isElement} from '../helpers/_utilities';

export const selector = '.js-scroll-to';

export default function () {

	return new Component({
		name: 'scrollTo',
		requiredTargets: selector,
		onCreate() {
		    this.handleClick = e => {
                const link = e.target.closest(selector);
		        if (isElement(link)) {
                    e.preventDefault();
                    const targetEl = $dom.get($dom.attr(link, 'href'));

                    if (isElement(targetEl)) {

                        targetEl.scrollIntoView({block: 'start', behavior: 'smooth'});
                    }
                }
            }
        },
		onInit() {
		    $events.delegate.on('click', selector, this.handleClick)
        },
		onDestroy() {
		    $events.delegate.on('click', selector, this.handleClick)
        }
	})
}
